import { Container } from '@plone/components';
import PropTypes from 'prop-types';
import { default as MobileNavigation } from '../MobileNavigation/MobileNavigation.jsx';
import { default as Navigation } from '../Navigation/Navigation.jsx';
import { LanguageSelector, Logo, SearchWidget } from '@plone/volto/components';

import React from 'react';
import WarningBlock from '../../../../../components/Blocks/WarningBlock/WarningBlock.jsx';
import FatalWarningBlock from '../../../../../components/Blocks/WarningBlock/FatalWarningBlock.jsx';
import QuickLinks from '../../../../../components/Blocks/Quicklinks/Quicklinks.jsx';

const Header = ({ pathname }) => {
  const isRoot = pathname === '/de' || pathname === '/en';

  return (
    <>
      <div
        className={`header-wrapper${isRoot ? ' is-root' : ''}`}
        role="banner"
      >
        <Container className="search">
          <SearchWidget />
        </Container>
        <Container className="header-wrap">
          <div className="header">
            <div className="logo-nav-wrapper">
              <div className="logo">
                <Logo />
              </div>
              <Navigation pathname={pathname} />
              <MobileNavigation pathname={pathname} />
              <LanguageSelector />
              {/* Uncomment to show Anontools when not logged in
            {!token && (
              <div className="tools">
                <Anontools />
              </div>
            )} */}
            </div>
          </div>
        </Container>
      </div>
      {isRoot && <QuickLinks />}
      <FatalWarningBlock />
      <WarningBlock />
    </>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
